import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let data = JSON.parse(localStorage.getItem('data')) || {}

let save_keys = ['vuex_adminListMode', 'vuex_setSpeaksTipsVisible']

const saveData = function (key, value) {
  if (save_keys.indexOf(key) > -1) {
    let tmp = JSON.parse(localStorage.getItem('data')) || {}
    tmp[key] = value
    localStorage.setItem('data', JSON.stringify(tmp))
  }
}
const store = new Vuex.Store({
  state: {
    vuex_appInfo: null,
    vuex_userInfo: null,
    vuex_adminListMode: data.vuex_adminListMode !== undefined ? data.vuex_adminListMode : 'list',
    vuex_setSpeaksTipsVisible: data.vuex_setSpeaksTipsVisible !== undefined ? data.vuex_setSpeaksTipsVisible : false
  },
  mutations: {
    mStore(state, payload) {
      let name_arr = payload.name.split('.')
      let key = ''
      let len = name_arr.length
      if (len >= 2) {
        let obj = state[name_arr[0]]
        for (let i = 1; i < len - 1; i++) {
          obj = obj[name_arr[i]]
        }
        obj[name_arr[len - 1]] = payload.value
        key = name_arr[0]
      } else {
        state[payload.name] = payload.value
        key = payload.name
      }
      saveData(key, state[key])
    }
  }
})

export default store
